import { render } from "./Texasauto.vue?vue&type=template&id=0a920df2&scoped=true"
import script from "./Texasauto.vue?vue&type=script&lang=js"
export * from "./Texasauto.vue?vue&type=script&lang=js"

import "./Texasauto.vue?vue&type=style&index=0&id=0a920df2&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a920df2"]])

export default __exports__